import { MDash } from 'ui-components/components/mdash/mdash';
import { Text, TextType } from 'ui-components/components/text';
import style from './style.module.less';

export const PackageOrConfirmationText = ({ value }) => {
  return (
    <>
      <span className={style.bullet}>&bull;</span>
      {value?.length > 0 ? <Text textType={TextType.Description} value={value} /> : <MDash />}
    </>
  );
};
